import { render, staticRenderFns } from "./eds-iit-checkbox.vue?vue&type=template&id=1c1b42da&lang=pug"
import script from "./eds-iit-checkbox.vue?vue&type=script&lang=js"
export * from "./eds-iit-checkbox.vue?vue&type=script&lang=js"
import style0 from "./eds-iit-checkbox.vue?vue&type=style&index=0&id=1c1b42da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports